import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import axiosInstance from 'src/utils/axios';

export interface NotRecommendedLineItem {
  poId: number;
  lineItemId: number;
  quantity: number;
  itemNum: string;
  description: string;
  glCode: string;
  uom: string;
  price: number;
  total: number;
  casePack: string;
  weight: string;
  catalogId: number;
  categoryId: number;
  productId: number;
  supplierId: number;
  supplierCompanyId: number;
  poGridId: number;
  buyerClientId: number;
  buyerCompanyId: number;
}

export type PoNotRecommendedLineItemsResponse = NotRecommendedLineItem[];

async function fetchPoNotRecommendedLineItems(
  poId: number,
  lineItemId?: number | null
): Promise<PoNotRecommendedLineItemsResponse> {
  const response = await axiosInstance.get<PoNotRecommendedLineItemsResponse>(
    api.getPoNotRecommendedLineItems(poId, lineItemId)
  );
  return response.data;
}

interface UseGetPoNotRecommendedLineItemsQueryOptions {
  poId: number | null | undefined;
  lineItemId?: number | null;
  enabled?: boolean;
}

const useGetPoNotRecommendedLineItemsQuery = ({
  poId,
  lineItemId,
  enabled = true,
}: UseGetPoNotRecommendedLineItemsQueryOptions) =>
  useQuery<PoNotRecommendedLineItemsResponse>({
    queryKey: queryKeys.po.notRecommendedLineItems(poId!, lineItemId),
    queryFn: () => fetchPoNotRecommendedLineItems(poId!, lineItemId),
    enabled: Boolean(poId) && enabled,
  });

export default useGetPoNotRecommendedLineItemsQuery;
